import { Image, View, Text, Line, Svg, StyleSheet } from "@react-pdf/renderer";
import { styles } from "./styles";

// Ícones não estavam sendo usados no trecho fornecido, mas mantive os imports caso precise depois
import cellIcon from "../../assets/icons/whatsapp.png";
import siteIcon from "../../assets/icons/mail.png";
import instaIcon from "../../assets/icons/insta.png";

export const TempHeaderPdf = ({
  relatorio,
  enterpriseConfig,
  sharedOptions,
}) => {
  const {
    logo,
    razaoSocial,
    cnpj,
    inscricaoEstadual,
    endereco,
    site,
    whatsapp,
    instagram,
    email,
  } = enterpriseConfig || {};

  return (
    <View style={headerStyles.container} fixed>
      <View style={headerStyles.topRow}>
        <View style={headerStyles.logoContainer}>
          <Image
            style={headerStyles.logo}
            src={`data:application/pdf;base64,${logo}`}
          />
        </View>

        {/* Bloco de Informações alinhado à Direita */}
        <View style={headerStyles.companyInfo}>
          {!!razaoSocial && (
            <Text style={headerStyles.razaoSocial}>{razaoSocial}</Text>
          )}
          <Text style={headerStyles.normalText}>
            {cnpj && `CNPJ: ${cnpj}`}
            {inscricaoEstadual &&
              `${cnpj ? " | " : ""}IE: ${inscricaoEstadual}`}
          </Text>

          {endereco && <Text style={headerStyles.normalText}>{endereco}</Text>}
        </View>
      </View>

      <Text
        style={[
          headerStyles.normalText,
          { marginTop: 1, textAlign: "center", marginBottom: -3 },
        ]}
      >
        {[site, email, formatPhone(whatsapp), instagram]
          .filter(Boolean)
          .join(" | ")}
      </Text>

      <Svg height="1" width="100%" style={headerStyles.divider}>
        <Line
          x1="0"
          y1="0"
          x2="800"
          y2="0"
          strokeWidth={1.5}
          stroke={"#78909C"}
        />
      </Svg>

      <Text
        style={headerStyles.pageFooter}
        render={({ pageNumber }) => {
          if (pageNumber > 1 && !!sharedOptions) {
            return `Período: ${sharedOptions?.dataInicial} ${sharedOptions?.horaInicial} à ${sharedOptions?.dataFinal} ${sharedOptions?.horaFinal}`;
          }
          return "";
        }}
      />
    </View>
  );
};

// Função auxiliar para formatar telefone
const formatPhone = (phone) => {
  if (!phone) return "";
  return phone.replace(/^(\d{2})(\d{4,5})(\d{4})$/, "($1) $2-$3");
};

const headerStyles = StyleSheet.create({
  container: {
    flexDirection: "column",
    position: "relative",
    marginTop: -10,
  },
  topRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
  },
  logoContainer: {
    width: "20%",
  },
  logo: {
    width: "100%",
    objectFit: "contain",
    maxHeight: 60,
  },
  companyInfo: {
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-end", // Alinha o container à direita (cross-axis do column)
    flex: 1, // Ocupa o restante do espaço
  },
  razaoSocial: {
    fontSize: 11,
    textAlign: "right", // Garante que o texto se alinhe à direita
  },
  normalText: {
    fontSize: 9,
    color: "#333",
    textAlign: "right",
  },
  divider: {
    marginBottom: 10,
    marginTop: 5,
  },
  pageFooter: {
    position: "absolute",
    bottom: 0,
    fontSize: 8,
    color: "#666",
  },
});
